import { combineReducers } from "@reduxjs/toolkit";
import { feedPostReducer } from "src/features/feed/state/feedPost/slice";

export const feedReducer = combineReducers({ post: feedPostReducer });
